import { Layout } from '../../components/Layout/Layout';
import { GroupsList } from '../../containers/GroupsList';
import { useTenantNameSubtitle } from '../../utils/customHooks/useTenantNameSubtitle';

export const GroupsListPage = () => {
  const tenantNameSubtitle = useTenantNameSubtitle();
  return (
    <Layout
      isMessageLayout
      message="home_groups"
      to="/dashboard"
      showBottomTabs
      subMessageText={tenantNameSubtitle}
      subMessageType="accent"
    >
      <GroupsList />
    </Layout>
  );
};
